const Act = {
	/** test */
	TEST_INFO: 'TEST_INFO',

	/** firebase */
	FIREBASE_LOGIN_USER: 'FIREBASE_LOGIN_USER',
	FIREBASE_LOGOUT_USER: 'FIREBASE_LOGOUT_USER',

	/** map */
	/** for TimelineMap component */
	MAP_INIT: 'MAP_INIT',
	LOADING_PAGE: 'LOADING_PAGE',
	SET_PUB_DATA: 'SET_PUB_DATA',
	SET_MAP_DATA: 'SET_MAP_DATA',
	SET_CLUSTER_POINTS: 'SET_CLUSTER_POINTS',
	/** for SearchInput component */
	CLEAN_QUERY: 'CLEAN_QUERY',
	START_SEARCH: 'START_SEARCH',
	FINISH_SEARCH: 'FINISH_SEARCH',
	UPDATE_SELECTION: 'UPDATE_SELECTION',
	/** for popUp */
	POP_UP_MODAL: 'POP_UP_MODAL',
	/** for MapTool component */
	FILE_EXPORT_STATUS: 'FILE_EXPORT_STATUS',
	DISPLAY_LOC_NAME: 'DISPLAY_LOC_NAME',
	SET_PALETTE_STYLE: 'SET_PALETTE_STYLE',
	SET_SHOW_RESULT_EXPORT: 'SET_SHOW_RESULT_EXPORT',
	/** for MapContainer component */
	SET_MAP_ELEMENT: 'SET_MAP_ELEMENT',
	SET_POINT_SELECT: 'SET_POINT_SELECT',
	SET_CUR_LAYER_TYPE: 'SET_CUR_LAYER_TYPE',
	/** for TimeLine component */
	/** add by bennis */
	TRANSFORM_MAP_DATA: 'TRANSFORM_MAP_DATA',
	TRANSFORM_SEARCH_DATA: 'TRANSFORM_SEARCH_DATA',
	/** SNA page */
	SNA_INIT: 'SNA_INIT',
	SNA_DB_DATA: 'SNA_DB_DATA',
	SNA_SNA_GRAPH_DATA: 'SNA_SNA_GRAPH_DATA',
	SNA_GRAPH_LEGENDS: 'SNA_GRAPH_LEGENDS',
	SNA_CUR_NODE: 'SNA_CUR_NODE',
	SNA_CUR_PUB_DATA: 'SNA_CUR_PUB_DATA',
	SNA_REGION_LIST: 'SNA_REGION_LIST',
	SNA_COUNTRY_LIST: 'SNA_COUNTRY_LIST',
};

export default Act;
